import { Box, Typography } from '@mui/material';
import React from 'react';
import { MultiChoiceAggregation as MultiChoiceAggregationType } from '../../redux/types';

type Props = {
  data: MultiChoiceAggregationType;
}

const MultiChoiceAggregation: React.FC<Props> = ({
  data,
}: Props) => (
  <Box>
    {
      Object.entries(data.payload).map(([key, val]) => (
        <Box key={key}>
          <Typography component="span">
            {`${val.text} `}
          </Typography>
          <Typography variant="body2" color="grey.500" component="span">
            {`×${val.count}`}
          </Typography>
        </Box>
      ))
    }
  </Box>
);

export default MultiChoiceAggregation;
